/*
  Catalog tier discount (display only).
  Checkout is permanently disabled on this store — this script only changes
  the prices shown on screen. Shopify's backend prices are never touched.

  Discount source priority: ?discount= URL param > sessionStorage > 0.
  Both sources are validated against ALLOWED_DISCOUNTS.
*/
(function () {
  var ALLOWED_DISCOUNTS = [0, 10, 20, 30, 40];
  var STORAGE_KEY = 'catalogDiscount';
  var DISCOUNT_COLOR = '#c00000';

  var currentDiscount = 0;
  // Guards the MutationObserver against reacting to this script's own price updates.
  var applying = false;

  function readDiscount() {
    var params = new URLSearchParams(window.location.search);
    if (params.has('discount')) {
      var fromUrl = parseInt(params.get('discount'), 10);
      if (ALLOWED_DISCOUNTS.indexOf(fromUrl) !== -1) {
        saveDiscount(fromUrl);
        return fromUrl;
      }
    }
    try {
      var stored = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
      if (ALLOWED_DISCOUNTS.indexOf(stored) !== -1) return stored;
    } catch (e) {
      /* sessionStorage unavailable (private mode etc.) — fall through to 0 */
    }
    return 0;
  }

  function saveDiscount(discount) {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(discount));
    } catch (e) {
      /* non-fatal: selection just won't persist across pages */
    }
  }

  // Keep ?discount= in the address bar in sync with the selected tier so any
  // copied/shared URL carries the discount. Facet filtering rewrites the URL
  // via pushState and drops the param, so this is re-run after grid updates.
  function syncUrl(discount) {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    var currentParam = url.searchParams.get('discount');
    if (discount === 0) {
      if (currentParam === null) return;
      url.searchParams.delete('discount');
    } else {
      if (currentParam === String(discount)) return;
      url.searchParams.set('discount', String(discount));
    }
    window.history.replaceState(window.history.state, '', url.toString());
  }

  function formatAmount(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function applyDiscount(discount) {
    applying = true;
    document.querySelectorAll('.product-price-container').forEach(function (el) {
      var originalCents = parseInt(el.getAttribute('data-original-price'), 10);
      if (isNaN(originalCents)) return;

      // Preserve the Liquid-rendered text (e.g. "From $59.99") so 0% restores it
      // exactly and prefixes/suffixes survive the discount rewrite.
      if (!el.hasAttribute('data-original-text')) {
        el.setAttribute('data-original-text', el.textContent.trim());
      }
      var originalText = el.getAttribute('data-original-text');

      if (discount === 0) {
        el.textContent = originalText;
        el.style.color = '';
      } else {
        var discountedCents = Math.round((originalCents * (100 - discount)) / 100);
        // Swap only the numeric portion so currency symbols and "From" survive.
        el.textContent = originalText.replace(/\d[\d,]*\.\d{2}|\d[\d,]*/, formatAmount(discountedCents));
        el.style.color = DISCOUNT_COLOR;
      }
    });
    // Let our own DOM mutations flush before re-arming the observer.
    window.setTimeout(function () {
      applying = false;
    }, 0);
  }

  function syncDropdowns(discount) {
    document.querySelectorAll('#CatalogDiscountSelect').forEach(function (select) {
      select.value = String(discount);
    });
  }

  function onDropdownChange(event) {
    var value = parseInt(event.target.value, 10);
    if (ALLOWED_DISCOUNTS.indexOf(value) === -1) value = 0;
    currentDiscount = value;
    saveDiscount(value);
    syncDropdowns(value);
    syncUrl(value);
    applyDiscount(value);
  }

  function containsPriceContainer(node) {
    return (
      node.nodeType === 1 &&
      (node.matches('.product-price-container') || node.querySelector('.product-price-container') !== null)
    );
  }

  function startObserver() {
    var debounceTimer = null;
    var observer = new MutationObserver(function (mutations) {
      if (applying || currentDiscount === 0) return;
      var hasNewPrices = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, containsPriceContainer);
      });
      if (!hasNewPrices) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        applyDiscount(currentDiscount);
        syncDropdowns(currentDiscount);
        syncUrl(currentDiscount);
      }, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    currentDiscount = readDiscount();
    syncDropdowns(currentDiscount);
    syncUrl(currentDiscount);
    if (currentDiscount !== 0) applyDiscount(currentDiscount);

    document.addEventListener('change', function (event) {
      if (event.target && event.target.id === 'CatalogDiscountSelect') {
        onDropdownChange(event);
      }
    });

    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
